import React,{Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { WithContext as ReactTags } from 'react-tag-input';
import { Popover, PopoverBody } from 'reactstrap';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import Header from '../Inc/Layout/Header.js';
import Footer from '../Inc/Layout/Footer.js';
import {  RULESMESSAGE } from '../../_constants';
import { SignUpAction } from '../../actions/SignUp';
import { getAllCityAction } from '../../actions/FindRecCompany';
import { addSpecializationAction, listSpecializationAction } from '../../actions/Speclization';
import { getAllHome } from '../../actions/home';
import { notification } from 'antd';
import 'antd/dist/antd.css';

let Validator = require('validatorjs');
let styleData = { color: "red" }
let formArr = {};
let rules = {
    email: 'required|email',
    userType: 'required',
};

let validation = [];
validation = new Validator([], rules, RULESMESSAGE);
validation.passes();
validation.fails();


let fieldsArr = [];
const KeyCodes = {
    comma: 188,
    enter: 13,
};
const delimiters = [KeyCodes.comma, KeyCodes.enter];

class SignUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldsList: [],
            fieldOption: [],
            cityOption: [],
            popoverOpen: false,
            Popover1: false,
            Popover2: false,
            formData: {
                userType: "recruiter",
                messageEmailNotification: true,
            },
            tags: [],
            tagValue: [],
            type: "user",
            suggestions: [],
            formArr: {}
        }
        this.handleDelete = this.handleDelete.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
    }

    componentWillMount() {
        this.props.listSpecializationAction();

        const { state } = this.props.location;
        const { formData } = this.state;
        if (state && state.userInfo) {
            formData.name = state.userInfo.localizedFirstName + " " + state.userInfo.localizedLastName;
            formData.email = state.userInfo.email;
            formData.linkedInId = state.userInfo.id;
        }

        this.setState({
            formData: formData
        })

        let reqObj = {
            "limit": 10,
            "offset": 0,
            "order": "name",
            "direction": "desc",
            "search": "",
            "status": ""
        }
        this.props.getAllHome(reqObj);
        this.props.getAllCityAction();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.specliZations && nextProps.specliZations && nextProps.specliZations.statusCode === 200) {
            if (nextProps.specliZations.data && nextProps.specliZations.data.data && nextProps.specliZations.data.data.length > 0) {
                var specliZationSugg = nextProps.specliZations.data.data;
                var spec = [];
                for (var x in specliZationSugg) {
                    spec.push({ id: specliZationSugg[x]._id, text: specliZationSugg[x].name })
                }
                this.setState({
                    suggestions: spec
                })
            }
        }

        if (nextProps && nextProps.signup && nextProps.signup.response.statusCode === 200) {
            var redirectPage = "";
            const userInfo = nextProps.signup.response.userData;
            if (userInfo) {
                localStorage.setItem('userData', JSON.stringify(userInfo))
                localStorage.setItem('JWTTOKEN', userInfo.token)
                localStorage.setItem('userLogin', true)
                if (userInfo && userInfo.userType === "user") {
                    redirectPage = this.props.auth.cityUrlFunction("/home");
                } else {
                    redirectPage = "/dashboard-home"
                }
                this.props.history.push({
                    pathname: redirectPage,
                    state: { "userInfo": userInfo }
                });
                notification.success({
                    message: "Signed in successfully",
                    className:'successNotification',
                    duration: 3
                });

            }

            
            // notification.success({
            //     message: nextProps.signup.response.msg,
            //     duration: 3
            // });
            // this.props.history.push({
            //     pathname: "/",
            //     state: {userData: nextProps.signup.response.data}
            // });

        } else if (nextProps && nextProps.signup && nextProps.signup.response.statusCode === 500) {
            notification.error({
                message: nextProps.signup.message,
                className:'errorNotification',
                duration: 3
            });
        }
        if (nextProps && nextProps.fields && nextProps.fields.length > 0) {
            var fieldsList = nextProps.fields
            var option = []
            for (var i in nextProps.fields) {
                let obj = {
                    value: fieldsList[i]._id,
                    label: fieldsList[i].name
                }
                option.push(obj);
            }
            this.setState({
                fieldsList: nextProps.fields,
                fieldOption: option

            })
        }

        if (nextProps.allCitySuggetion && nextProps.allCitySuggetion.statusCode === 200) {
            let cityData = (nextProps.allCitySuggetion.cityData && nextProps.allCitySuggetion.cityData.data) ? nextProps.allCitySuggetion.cityData.data : [];
            let cityArr = [];
            for (var k in cityData) {
                let obj = {};
                obj.label = cityData[k].cityName;
                obj.city = cityData[k].cityName;
                obj.value = cityData[k]._id;
                obj.state = cityData[k].stateId;
                obj.state = cityData[k].stateName;
                obj.country = cityData[k].countryName;
                obj.zipCode = "";
                obj.countryId = cityData[k].countryId;
                obj.address = cityData[k].cityName;
                obj.coordinates = cityData[k].coordinates;
                cityArr.push(obj);
            }
            // console.log("cityArr", cityArr);
            this.setState({
                cityOption: cityArr
            })
        }
    }

    toggle(name,e) {
        this.setState({
            [name]: !this.state[name]
        });
    }

    fields() {
        fieldsArr = [];
        const { fieldsList } = this.state
        var i = 0;
        for (i in fieldsList) {
            fieldsArr.push(<div className="col-md-6"><input type="checkbox" name="fields" id={fieldsList[i]._id} value={fieldsList[i]._id} onChange={this.handleChangeRadio} />{fieldsList[i].name}</div>)
        }
    }

    handleChangeRadio = (e) => {
        let formData = this.state.formData
        formData["userType"] = e.target.value
        this.setState({
            formData: formData
        });
    }

    handleChangeradioForRadio = (value, e) => {
        let formData = this.state.formData;
        formData.messageEmailNotification = value;
        this.setState({
            formData: formData,
        })
    }

    handleChangeType = (e) => {
        let type = this.state.type
        let formData = this.state.formData
        type = e.target.value
        if (e.target.value === "user") {
            if(rules.field ||rules.companyAddress){
                delete rules.field;
                delete rules.companyAddress;
            }
            formData["userType"] = e.target.value
        }else{
            rules.field = 'required';
            rules.companyAddress = 'required';
            formData["userType"] = "recruiter"
        }
        
        this.setState({
            type: type,
            formData: formData
        });
    }

    handleChange = (e) => {
        e.preventDefault()
        let formData = this.state.formData ;
        let value = e.target.value;
        if(e.target.name == "name"){
           value =  value.charAt(0).toUpperCase() + value.slice(1);
        }
        console.log("value",value, e.target.name)
        formData[e.target.name] = value;
        this.setState({
            formData: formData
        });
    }

    handleChangeSelect = (name, value) => {
        let formData = this.state.formData
        formData[name] = value
        this.setState({
            formData: formData
        });
    }

    handleDelete(i) {
        const { tags, tagValue } = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
            tagValue: tagValue.filter((tagValue, index) => index !== i),
        });
    }

    handleAddition(tag) {
        var tagValue = tag.text;
        this.setState(state => ({ tags: [...state.tags, tag] }));
        this.setState(state => ({ tagValue: [...state.tagValue, tagValue] }));
    }

    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];
        const newTags = tags.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        this.setState({ tags: newTags });
    }

    submitFrom = () => {
        const { formData, tagValue, type } = this.state;
        var categoryId = []
        if (formData && formData.field && formData.field.length > 0) {
            for (var x in formData.field) {
                categoryId.push(formData.field[x].value)
            }
        }
        //this.state.formData
        if (type === "user") {
            formData.userType = "user";
        }
        let reqObj = {
            "firstName": formData.name,
            "email": formData.email,
            "categoryId": categoryId,
            "companyAddress":formData.companyAddress,
            "linkedInId": formData.linkedInId,
            "shortBio": formData.shortBio,
            "specializations": tagValue,
            "userType": formData.userType
        }
        if (this.allValidate(false)) {
            this.props.SignUpAction(reqObj);
        }
    }

    handleChangeSelectCity = (name, value) => {
        let formData = this.state.formData
        formData.companyAddress = value;
        this.setState({
            formData: formData
        });
    }

    allValidate(check) {
        if (!check) {
            formArr = []
            Object.keys(rules).forEach(function(key) {
                formArr[key] = "TT";
            });
            this.setState({
                formArr
            });

        }
        if (validation.passes()) {
            return 1;
        }
    }

    render() {
        this.fields()
        const { formData, tags, suggestions, fieldOption, type, cityOption } = this.state
        validation = new Validator(formData, rules, RULESMESSAGE);
        validation.passes();
        validation.fails();

        return (
            <div className="all-page-wrapper">
                <Header props={this.props }/>
                    <div className="page-wrapper">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6 mlr-auto">
                                   <div className="bg-signup">
                                        <div className="signIn-section">
                                            <h3>Sign Up</h3>
                                            <div className="form-group">
                                                <label>Name<span>*</span></label> 
                                                <input type="text" className="form-control singup-control" name="name" onChange={this.handleChange}  placeholder="" value={formData.name} />
                                            </div>
                                            <div className="form-group">
                                                <label>Email<span>*</span></label>
                                                <input type="text" className="form-control singup-control" name="email" disabled readOnly placeholder="" value={formData.email} />
                                                <span style={styleData} className="error">{this.state.formArr.email && validation.errors.first('email')}</span>
                                            </div>

                                            <div className="form-group">
                                                <label>Short-Bio</label>
                                                <input type="text" className="form-control singup-control" name="shortBio" onChange={this.handleChange}  placeholder="" value={formData.shortBio} />
                                            </div>
                                            {type==="jobProvider" &&
                                                <span> 
                                                    <div className="form-group">
                                                        <label>Category<span>*</span></label>
                                                         <Select 
                                                           name="field" 
                                                           className="singup-control"
                                                           isMulti
                                                           closeMenuOnSelect={false}
                                                           components={makeAnimated()}
                                                           value={formData.field}
                                                           onChange={this.handleChangeSelect.bind(this, "field")}
                                                           options={fieldOption}
                                                           placeholder="Select Category"
                                                        />
                                                        <span style={styleData} className="error">{this.state.formArr.field && validation.errors.first('field')}</span>

                                                    </div>
                                                     <div className="form-group">
                                                        <label className="pf-label" htmlFor="city"> City </label>
                                                        <Select name="companyAddress" className="singup-control" isMulti closeMenuOnSelect={false} components={makeAnimated()} value={formData.companyAddress} onChange={this.handleChangeSelectCity.bind(this, "city" )} options={cityOption} disabled={true} placeholder="Select City" />
                                                        <span style={styleData} className="error">{this.state.formArr.companyAddress && validation.errors.first('companyAddress')}</span>
                                                    
                                                    </div>
                                                    <div className="form-group">
                                                        {(formData.userType==="recruiter")&&
                                                
                                                            <div className="spe-input">
                                                                <label>Speciality</label>
                                                                <ReactTags 
                                                                    className="form-control singup-control"
                                                                    tags={tags}
                                                                    suggestions={suggestions}
                                                                    handleDelete={this.handleDelete}
                                                                    handleAddition={this.handleAddition}
                                                                    handleDrag={this.handleDrag}
                                                                    delimiters={delimiters} />
                                                            </div>
                                                        }
                                                    </div>
                                                </span>
                                            }
                               
                                            <div className="form-group row new-radio-block">
                                                <label className="pf-label">Do you want to receive email notification for any communication through arightconnection</label>
                                                <span className="radio-signups">
                                                    <input type="radio" className="new-radio-btn" name="radioNotificatio" id="yesNotification" onChange={this.handleChangeradioForRadio.bind(this,true)} checked={formData.messageEmailNotification===true}  /><label className="cus-radio-label" htmlFor="yesNotification">Yes</label>
                                                    <input type="radio" className="new-radio-btn" name="radioNotificatio" id="noNotification" onChange={this.handleChangeradioForRadio.bind(this,false)} checked={formData.messageEmailNotification===false}  /><label className="cus-radio-label" htmlFor="noNotification">No</label>
                                                </span>
                                            </div>
                                            <div className="form-group row new-radio-block">
                                                 <span className="radio-signups">
                                                    <input type="radio" className="new-radio-btn" id="jobSeekers" name="jobSeekers" value="user" checked={type === "user"} onChange={this.handleChangeType} />
                                                    <label className="cus-radio-label" htmlFor="jobSeekers">Job Seeker</label>
                                                </span>

                                                  <span className="radio-signups">
                                                    <input type="radio" className="new-radio-btn" id="jobProvider" name="jobProvider" value="jobProvider" checked={type === "jobProvider"} onChange={this.handleChangeType} />
                                                    <label className="cus-radio-label" htmlFor="jobProvider">Job Provider / Career Coach</label>
                                                </span>

                                            </div>

                                            {/* type==="jobProvider" && 
                                                 <div className="form-group row new-radio-block">
                                                     <span className="radio-signups">
                                                        <input type="radio" className="new-radio-btn" id="radio_1" name="userType"  value="recruiter" checked={formData.userType === "recruiter"} onChange={this.handleChangeRadio} />
                                                        <label className="cus-radio-label" htmlFor="radio_1">Recruiter</label>
                                                     </span>
                                                  { <span className="radio-signups">
                                                        <input type="radio" className="new-radio-btn" id="radio_2" name="userType"  value="company"   checked={formData.userType === "company"} onChange={this.handleChangeRadio} />
                                                        <label className="cus-radio-label" htmlFor="radio_2">Company</label>
                                                   </span>}
                                                <span className="radio-signups pop-I"  id="Popover2">
                                                    <i className="fa fa-info"  aria-hidden="true"></i>
                                                </span>
                                                 <Popover placement="right-start" trigger="hover" isOpen={this.state.Popover2} target="Popover2" toggle={this.toggle.bind(this,"Popover2")}>
                                                    <PopoverBody>If you are recruiting for other companies please select Recruiter and If you are a recruiting for your own company please select Company.</PopoverBody>
                                                </Popover>
                                                </div>
                                           */ } 
                        
                                            <div className="form-group">
                                                <button type="button" className="btn submit-btn" onClick={this.submitFrom}>Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        fields: state.home.response.data,
        allCitySuggetion: state.FindRecCompany.allCitySuggetion,
        specliZations: state.Speclization.response,
        signup: state.SignUp
    };
}

export default withRouter(connect(mapStateToProps, {
    getAllHome,
    SignUpAction,
    getAllCityAction,
    listSpecializationAction,
    addSpecializationAction
})(SignUp));


// WEBPACK FOOTER //
// ./src/components/SignUp/SignUp.js